import { Task, TaskProvider } from '../types';

export class DailyTasksAdapter {
  static adaptTasks(data: any): Task[] {
    console.log('🔄 DailyTasksAdapter.adaptTasks - start', { data });
    
    try {
      const tasks = data?.tasks?.tasks || data?.tasks || data || [];
      if (!Array.isArray(tasks)) {
        throw new Error('Invalid tasks data structure');
      }
      return tasks.map(DailyTasksAdapter.adaptTask);
    } catch (error) {
      console.error('❌ DailyTasksAdapter.adaptTasks - error', error);
      throw error;
    }
  }

  private static adaptTask(task: any): Task {
    return {
      id: task.id,
      title: task.name,
      icon: task.icon,
      type: 'quest-daily',
      rewards: {
        dc: task.rewards.find((r: any) => r.type === 'dc')?.amount,
        tickets: task.rewards.find((r: any) => r.type === 'tickets')?.amount
      },
      status: task.status,
      progress: {
        current: task.user_progress || 0,
        total: task.target_progress || 1
      },
      buttonText: DailyTasksAdapter.getButtonText(task.slug),
      provider: 'DAILY' as TaskProvider
    };
  }

  private static getButtonText(slug: string): string {
    switch (slug) {
      case 'invite-referral':
        return 'Пригласить';
      default:
        return 'Выполнить';
    }
  }
} 